import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

// Zoom brand mark — a video camera in Zoom blue. The fill is set per-path so
// `currentColor` on the wrapping svg does not affect it.
const Zoom = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            fill="#2D8CFF"
            d="M3 8.5A2.5 2.5 0 0 1 5.5 6h8A2.5 2.5 0 0 1 16 8.5v7A2.5 2.5 0 0 1 13.5 18h-8A2.5 2.5 0 0 1 3 15.5z"
        />
        <path
            fill="#2D8CFF"
            d="M17.5 10.2l3.2-2.3c.66-.48 1.6-.02 1.6.8v6.6c0 .82-.94 1.28-1.6.8l-3.2-2.3z"
        />
    </SvgIcon>
);

export default Zoom;
